import { useCallback, useEffect } from 'react';

import { Form } from 'formik';
import { Col, Row } from 'reactstrap';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import SubmitButton from 'src/app/components/Elements/Button/Submit';
import { Card, CardItem } from 'src/app/components/Elements/Card';
import { DevOnly } from 'src/app/components/Elements/DevOnly';
import { ToolTip } from 'src/app/components/Elements/ToolTip';
import GenericErrors from 'src/app/components/Error/Generic';
import {
  TextInputStripe,
  FieldOptions as TextInputStripeFieldOptions,
} from 'src/app/components/Form/TextInputStripe/container';
import { segmentTrack } from 'src/app/state/actions';
import { useDispatch } from 'src/app/state/store';

const preventDefault = e => {
  e.preventDefault();
};

const AccountPageAddCreditCard = ({ isSubmitting, handleSubmit, errors }) => {
  const dispatch = useDispatch();
  const dispatchSegmentTrack = useCallback(
    (event: UnifiedEvent, payload: any) => dispatch(segmentTrack(event, payload) as any),
    [dispatch]
  );
  useEffect(() => {
    dispatchSegmentTrack(UNIFIED.viewAddCreditCard, { source: 'Your Account' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DevOnly>
        <p>expirationDate: Any future MM/YY!</p>
        <p>securityCode: 123</p>
        &nbsp;&nbsp;&nbsp;
        <Row>
          <Col sm={12} md={6}>
            <h3>BAD DATA</h3>
            <p>5555 5555 5555 5555</p>
            &nbsp;&nbsp;&nbsp;
            <h3>DECLINED</h3>
            <p>4000000000000002</p>
            &nbsp;&nbsp;&nbsp;
            <h3>PROCESSING ERROR</h3>
            <p>4000000000000119</p>
            &nbsp;&nbsp;&nbsp;
            <h3>BAD CVC</h3>
            <p>4000000000000127</p>
          </Col>
          <Col sm={12} md={6}>
            <h3>EXPIRED</h3>
            <p>4000000000000069</p>
            &nbsp;&nbsp;&nbsp;
            <h3>AUTH FAIL</h3>
            <p>4000000000000341</p>
            &nbsp;&nbsp;&nbsp;
            <h3>Visa</h3>
            <p>4242 4242 4242 4242</p>
            &nbsp;&nbsp;&nbsp;
            <h3>AMEX</h3>
            <p>378282246310005</p>
            &nbsp;&nbsp;&nbsp;
            <h3>Diners</h3>
            <p>30569309025904</p>
          </Col>
        </Row>
      </DevOnly>
      <GenericErrors />
      <Form onSubmit={isSubmitting ? preventDefault : handleSubmit}>
        <Card>
          <CardItem>
            <TextInputStripe
              apiError={errors?.cardNumber}
              stripeFieldType={TextInputStripeFieldOptions.cardNumber}
              label="Card number"
              dataCy="credit-card-number"
            />
            <Row>
              <Col sm={12} lg={6}>
                <TextInputStripe
                  apiError={errors?.expirationDate}
                  stripeFieldType={TextInputStripeFieldOptions.date}
                  label="MM/YY"
                  dataCy="credit-card-expiration-date"
                />
              </Col>
              <Col sm={12} lg={6}>
                <TextInputStripe
                  apiError={errors?.securityCode}
                  stripeFieldType={TextInputStripeFieldOptions.cvc}
                  label="Security code"
                  dataCy="credit-card-security-code"
                />
              </Col>
            </Row>
          </CardItem>
        </Card>

        <SubmitButton data-cy={'account-add-credit-card'} size="medium" style="secondary" block disabled={isSubmitting}>
          Save
        </SubmitButton>
      </Form>

      <div className="mt-4 d-flex justify-content-center">
        <ToolTip
          anchorText="Capsule accepts HSA and FSA cards."
          header="Capsule accepts HSA and FSA cards."
          body="You can download a receipt from Your Orders after your order has been delivered."
          analyticTip="HSA FSA cards"
        />
      </div>
    </>
  );
};

export default AccountPageAddCreditCard;
